import { gql } from '@/__generated__';

export const setProductActiveDocument = gql(/* GraphQL */ `
  mutation SetProductActive($id: String!, $active: Boolean!) {
    updateProduct(where: { id: $id }, data: { active: { set: $active } }) {
      id
      active
    }
  }
`);

export const setProductCanRemoveDocument = gql(/* GraphQL */ `
  mutation SetProductCanRemove($id: String!, $canRemove: Boolean!) {
    updateProduct(where: { id: $id }, data: { canRemove: { set: $canRemove } }) {
      id
      canRemove
    }
  }
`);

export const incrementProductVariantStockDocument = gql(/* GraphQL */ `
  mutation IncrementProductVariantStock($productVariantId: String!, $increment: Int!) {
    incrementVariantStock(productVariantId: $productVariantId, increment: $increment) {
      id
      stock
    }
  }
`);

export const decrementProductVariantStockDocument = gql(/* GraphQL */ `
  mutation DecrementProductVariantStock($productVariantId: String!, $decrement: Int!) {
    decrementVariantStock(productVariantId: $productVariantId, decrement: $decrement) {
      id
      stock
    }
  }
`);

export const removeProductVariantFromOrdersDocument = gql(/* GraphQL */ `
  mutation RemoveProductVariantFromOrders($productVariantId: String!, $message: String!) {
    removeProductVariantFromOrders(productVarianId: $productVariantId, message: $message)
  }
`);

export const removeProductVariantOrderLineDocument = gql(/* GraphQL */ `
  mutation RemoveProductVariantOrderLine($lineId: String!, $message: String!) {
    removeProductVariantOrderLine(lineId: $lineId, message: $message)
  }
`);

export const addVariantToProductDocument = gql(/* GraphQL */ `
  mutation AddVariantToProduct(
    $productId: String!
    $stock: Int!
    $attributes: [ProductVariantAttributeCreateWithoutVariantInput!]!
  ) {
    addVariantToProduct(productId: $productId, stock: $stock, attributes: $attributes) {
      id
      stock
      attributes {
        id
        name
        value
      }
    }
  }
`);

export const bulkUpdateProductPriceDocument = gql(/* GraphQL */ `
  mutation BulkUpdateProductPrice($productId: String!, $newPrice: Int!, $message: String!) {
    bulkUpdateProductPrice(productId: $productId, newPrice: $newPrice, message: $message)
  }
`);

export const bulkUpdateProductDetailsDocument = gql(/* GraphQL */ `
  mutation BulkUpdateProductDetails(
    $productId: String!
    $newName: String!
    $newDescription: String
  ) {
    bulkUpdateProductDetails(
      productId: $productId
      newName: $newName
      newDescription: $newDescription
    )
  }
`);

export const countActiveCartsForProductDocument = gql(/* GraphQL */ `
  query CountActiveCartsForProduct($productId: String!) {
    countOrders(
      where: {
        status: { equals: CREATED }
        lines: { some: { productVariant: { is: { productId: { equals: $productId } } } } }
      }
    )
  }
`);
